/*=========================================================================================
  File Name: module-usertax-actions.js
  Description: UserTax Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import UserTaxAPI from '@/api/UserTaxAPI.js';
import httpClient from '../../api/axios-httpclient';
import commonFunc from '@/common/commonFunction';
import { MSEnum } from '@/common/enumeration';

export default {
	logout: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: UserTaxAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + '/logout',
			data: payload
		});
		// Trả kết quả
		return res;
	},

	/**
	 * Lấy danh sách người dùng
	 */
	loadUserList: async function(context, payload) {
		context.commit('updateUserListLoaded', false);
		let res = await httpClient.getAsync(
			{
				url: UserTaxAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()),
				params: payload
			},
			true
		);
		if (res && res.Success) {
			context.commit('updateUserList', res);
		}
		context.commit('updateUserListLoaded', true);
		// Trả kết quả
		return res.Data;
	},

	/**
	 * Cập nhật user đã hiển thị hướng dẫn
	 */
	updateViewGuide: async function(context, payload) {
		let res = await httpClient.putAsync({
			url: UserTaxAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + '/guide/' + payload.Id
		});
		if (res && res.Success) {
			context.commit('updateGuide', res.Data);
			return res.Data;
		}

		// Trả kết quả
		return res.Data;
	},

	/**
	 * Cập nhật user đã hiển thị hướng dẫn các tính năng của R18
	 */
	updateViewGuideV2: async function(context, payload) {
		let res = await httpClient.putAsync({
			url: UserTaxAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + '/guidev2/' + payload.Id,
			data: payload
		});
		if (res && res.Success) {
			if (payload.ViewGuideLiveChatStatus) {
				context.commit('updateGuideV2', payload.ViewGuideLiveChatStatus);
			} else {
				context.commit('updateGuideV2', 1);
			}
			return res.Data;
		}
		// Trả kết quả
		return res.Data;
	},

	/**
	 * Cập nhật phiên bản cho người dùng
	 */
	updateVersionGuide: async function(context, payload) {
		let res = await httpClient.putAsync({
			url: UserTaxAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + '/newversion/' + payload.Id
		});
		if (res && res.Success) {
			context.commit('updateNewVersion', res.Data);
			return res.Data;
		}
		// Trả kết quả
		return res.Data;
	},
	/**
	 * Cập nhật trạng thái đã xem tour guide thanh công cụ trên màn Tổng quan
	 * Mỗi user chỉ được hướng dẫn 1 lần
	 */
	updateWatchedToolbarGuide: async function(context, payload) {
		let res = await httpClient.putAsync({
			url: UserTaxAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + '/toolbarguide/' + payload.Id
		});
		if (res && res.Success && res.Data) {
			context.commit('updateWatchedToolbarGuide', true);
			return res.Data;
		}
		// Trả kết quả
		return null;
	},
	/**
	 * Created by pddang 22/09/2026
	 * Cập nhật trạng thái đã chọn "Không hiển thị lại" trên popup
	 * "Bạn có biết: Có thể rút ngắn Mẫu hóa đơn mặc định" (PBI 677171)
	 * Lưu theo từng user
	 */
	updateWatchedShortenTemplateGuide: async function(context, payload) {
		let res = await httpClient.putAsync({
			url: UserTaxAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + '/templateguide/' + payload.Id
		});
		if (res && res.Success && res.Data) {
			context.commit('updateWatchedShortenTemplateGuide', true);
			return res.Data;
		}
		// Trả kết quả
		return null;
	},
	/**
	 * Cập nhật trạng thái đã xem bù bước "Thiết lập hệ thống" của tour guide thanh công cụ
	 * Mỗi user chỉ được hướng dẫn bước này 1 lần
	 */
	updateWatchedToolbarGuideStep3: async function(context, payload) {
		let res = await httpClient.putAsync({
			url: UserTaxAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + '/toolbarguidestep3/' + payload.Id
		});
		if (res && res.Success && res.Data) {
			context.commit('updateWatchedToolbarGuideStep3', true);
			return res.Data;
		}
		// Trả kết quả
		return null;
	},
	/**
	 * Cập nhật trạng thái đã xem tour guide phân hệ Hóa đơn đầu vào
	 * Mỗi user chỉ được hướng dẫn 1 lần
	 */
	updateWatchedInvoiceInputGuide: async function(context, payload) {
		let res = await httpClient.putAsync({
			url: UserTaxAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + '/invoiceinputguide/' + payload.Id
		});
		if (res && res.Success && res.Data) {
			context.commit('updateWatchedInvoiceInputGuide', true);
			return res.Data;
		}
		// Trả kết quả
		return null;
	},
	/**
	 * Lấy thông tin user khi đăng nhập để lấy các giá trị quyền, vai trò quyền hạn
	 */
	getUserInfo: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: UserTaxAPI.getAPIUrl() + `/info`
				// data: payload
			},
			false,
			false
		);
		if (res && res.Success) {
			//Cập nhật phiên bản
			commonFunc.resetStateConfig(res.Data ? res.Data.Version : '');
			//Cập nhật role, user, workPermission
			context.commit('updateRole', res.Data);
			context.commit('updateUser', res.Data);
			context.commit('updateWorkPermission', res.Data);
			return res.Data;
		}
		return null;
	},

	/**
	 * Lấy thông tin user khi sửa
	 */
	getUserInfoById: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: UserTaxAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + `/${payload.Id}`
			},
			true
		);
		if (res && res.Success) {
			return res.Data;
		}
		return null;
	},

	/**
	 * Gửi kết quả khảo sát lên nps
	 */
	sendServeyNpsForUser: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: UserTaxAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + '/send-nps',
			data: payload
		});
		if (res && res.Success) {
			return res.Data;
		}
		return null;
	},

	/**
	 * User có được show popup hay không
	 */
	getCheckServeyUser: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: UserTaxAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + '/check-servey',
			params: payload
		});
		if (res && res.Success) {
			context.commit('updateCheckServeyUser', true);
			return res.Data;
		}
		return null;
	},

	/**
	 * Lấy danh sách khảo sát theo user
	 * @returns
	 */
	getListServeyUser: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: UserTaxAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + '/list-servey',
			params: payload
		});
		if (res && res.Success) {
			return res.Data;
		}
		return null;
	},

	/**
	 * Gửi kết quả khảo sát lên nps
	 */
	updateCancelCountForUser: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: UserTaxAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + '/update-cancel-count',
			data: payload
		});
		if (res && res.Success) {
			return res.Data;
		}
		return null;
	},

	/**
	 * Tạo mới người dùng
	 */
	createUser: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: UserTaxAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + '/create',
				data: payload
			},
			true
		);
		return res;
	},

	/**
	 * Sửa thông tin người dùng
	 */
	editUser: async function(context, payload) {
		let res = await httpClient.putAsync(
			{
				url: UserTaxAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + '/update',
				data: payload
			},
			true
		);
		return res;
	},

	/**
	 * Cập nhật hàng loạt người dùng (batch update)
	 * @param {Object} payload - Dữ liệu batch update bao gồm UserIds, RoleId, AccessOnOrgs, etc.
	 * @returns {Promise} Response từ API
	 */
	batchUpdateUsers: async function(context, payload) {
		let res = await httpClient.putAsync(
			{
				url: UserTaxAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + '/batch-update',
				data: payload
			},
			true
		);
		return res;
	},

	/**
	 * Xóa người dùng
	 */
	deleteUser: async function(context, payload) {
		let res = await httpClient.deleteAsync(
			{
				url: UserTaxAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + '/delete/' + payload.Id
			},
			true
		);
		if (res && res.Success) {
			context.commit('deleteUser', payload);
		}
		return res;
	},

	/**
	 * Lấy danh sách chức danh
	 */
	loadJobTitles: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: UserTaxAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + `/jobtitle`
			},
			true
		);
		if (res.Success && res.Data && res.Data.length > 0) {
			context.commit('updateTitles', res.Data);
			return res.Data;
		}

		// Trả kết quả
		return [];
	},

	/**
	 * Thêm mới chức danh
	 */
	createJobTitleUser: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: UserTaxAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + '/createjobtitle',
				data: payload
			},
			true
		);
		return res;
	},
	/**
	 * Cập nhật đã show thông báo tính năng hóa đơn đầu ra đối với từng user
	 */
	updateShowNotifyUserAsync: async function(context, payload) {
		let res = await httpClient.putAsync({
			url: `${UserTaxAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly())}/update-shownotify-user`
		});
		if (res.Success && res.Data) {
			context.commit('updateShowNotify', true);
			return res.Data;
		}
		//Trả kết quả
		return res.Data;
	},

	updateViewInvoiceDetailAsync: async function(context, payload) {
		//Gắn dữ liệu mặc định khi không xác định được dữ liệu
		if (payload && !payload.viewCheckingResult) {
			payload.viewCheckingResult = MSEnum.ViewCheckingResult.Normal;
		}
		let res = await httpClient.putAsync({
			url: `${UserTaxAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly())}/update-view-invoice-detail/${
				payload.viewInvoiceDetail
			}/${payload.viewCheckingResult}`
		});
		if (res.Success && res.Data) {
			context.commit('updateViewInvoiceDetail', payload.viewInvoiceDetail);
			return res.Data;
		}
		//Trả kết quả
		return res.Data;
	},

	getTokenFromMWS: async function(content, payload) {
		let res = await httpClient.postAsync({
			url: `${UserTaxAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly())}/token-mws`,
			data: payload
		});
		if (res.Success && res.Data) {
			return res.Data;
		}
		// Trả kết quả
		return null;
	},
	/**
	 * Lấy tổng số bản ghi trên danh sách
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 */
	getTotalPageAsync: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: UserTaxAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + `/total`,
			data: payload
		});
		if (res && res.Success) {
			context.commit('updateTotalPage', res.Data);
		}
		return 0;
	},

	getChatbotConnect: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: UserTaxAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + '/init-chatbot',
			params: payload
		});
		if (res && res.Success) {
			return res.Data;
		}
		return null;
	},

	/**
	 * Cập nhật user đã hiển thị quảng cáo ava chatbot
	 */
	updateViewedAvaChatbot: async function(context, payload) {
		let res = await httpClient.putAsync({
			url: `${UserTaxAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly())}/viewed-chatbot-adv/`
		});
		if (res && res.Success) {
			context.commit('updateShowAvaAdv', res.Data);
			return res.Data;
		}
		// Trả kết quả
		return res.Data;
	},

	updateUserConfig: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: UserTaxAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + `/updateconfiguser`,
			data: payload
		});
		if (res.Success && payload) {
			context.commit('updateStateUserConfig', payload.UserConfig);
			return true;
		}
		return false;
	},

	getUserConfig: async function(context, payload) {
		//Thi thoảng đơn vị vừa mua chưa có subscriberId
		let subscriberId = commonFunc.getSubParamSubOnly();
		if (!subscriberId) return null;

		let res = await httpClient.getAsync({
			url: UserTaxAPI.getAPIUrlSubParam(subscriberId) + `/configuser`
		});
		if (res && res.Success) {
			context.commit('updateStateUserConfig', res.Data);
			return res.Data;
		}
		return null;
	},

	getCommunity: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: UserTaxAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + '/community/connect',
			params: payload
		});
		if (res && res.Success) {
			return res.Data;
		}
		return null;
	},

	getTokenLearnWithMISA: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: UserTaxAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + '/misalearning/connect',
			params: payload
		});
		if (res && res.Success && res.Data) {
			return res.Data;
		}
		return null;
	},

	updateStatusViewedFilm: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: UserTaxAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + '/viewed-film',
			data: payload
		});
		if (res.Success && res.Data) {
			context.commit('updateViewedFilm', res.Data);
			return res.Data;
		}
		// Trả kết quả
		return res.Data;
	},

	updateShowUnclassifiedCost: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: UserTaxAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + '/update-show-unclassified-cost',
			data: payload
		});
		if (res && res.Data) {
			context.commit('updateShowUnclassifiedCost', res.Data);
			return res.Data;
		}

		return false;
	},

	/**
	 * Lấy danh sách cấu hình tooltip tính năng mới
	 * không có cache vì sự thay đổi cấu hình từ server mà client không biết được
	 */
	getFeatureToolTipConfig: async function(context, payload) {
		const currentVersion = commonFunc.getCurrentRoundVersion();
		let res = await httpClient.getAsync({
			url: `${UserTaxAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly())}/feature-tooltips/${currentVersion}`
		});
		if (res && res.Success) {
			context.commit('updateFeatureTooltipConfig', res.Data);
			return res.Data;
		}
		// Trả kết quả
		return null;
	}
};
